import { WALLET_URL } from 'constants/config';
import { fetch } from 'services/apiV3/fetch';
import { fetchJson } from 'utils/fetchJson/fetchJson';

const UserService = {
  fetchCreditCards: () => {
    const options = { method: 'GET' };

    return fetch(WALLET_URL, options);
  },

  removeCreditCard: token => {
    const options = { method: 'DELETE' };

    const url = `${WALLET_URL}/${token}`;

    return fetch(url, options);
  },

  saveCard: async card => {
    const customer = await createCardCustomer(card);
    const oppCard = await saveCardToOpp(card, customer);
    return saveCardToWallet(oppCard, customer);
  },
};

const createCardCustomer = card => {
  const { name, surname, email } = card;
  const method = 'POST';
  const body = JSON.stringify({ first_name: name, last_name: surname, email });
  const options = { method, body };
  const url = `${WALLET_URL}/customers`;

  return fetch(url, options);
};

const saveCardToOpp = async (card, customer) => {
  const { accessKey, accessToken, vaultUrl, customerToken } = customer;

  if (!vaultUrl) {
    throw new Error(customer);
  }

  const {
    name: accountFirstName,
    surname: accountLastName,
    cardNumber,
    cvv,
    cardType,
    expiryDate,
    billingAddress,
  } = card;

  const [expireMonth, expireYear] = expiryDate.split('/');
  const accountNumber = cardNumber.split('-').join('');

  const body = JSON.stringify({
    customer: { token: customerToken },
    paymentMethod: {
      isEcheck: false,
      accountFirstName,
      accountLastName,
      accountNumber,
      CVV: cvv,
      type: cardType,
      expireMonth: expireMonth,
      expireYear: `20${expireYear}`,
      billingAddress,
    },
    authenticationRequest: {
      accessToken,
      key: accessKey,
    },
  });

  const method = 'POST';
  const headers = { 'Content-Type': 'text/plain' };
  const options = { method, headers, body };

  const response = await fetchJson(vaultUrl, options);

  if (!response.operationResult) {
    throw new Error();
  }

  return response;
};

const saveCardToWallet = (oppCard, customer) => {
  const {
    operationResultObject: {
      lastFour,
      token: { value: nonce },
    },
  } = oppCard;
  const { customerToken } = customer;

  const url = `${WALLET_URL}/cards`;
  const body = JSON.stringify({
    last_four: lastFour,
    nonce,
    customer: customerToken,
  });
  const options = { method: 'POST', body };

  return fetch(url, options);
};

export { UserService as wallet };
